<template>
  <div class="xm" ref="imgg">
    <div class="fd"></div>
    <img :src="src" alt="" ref="src" width="100%">
  </div>
</template>

<script>
export default {
props:{
        src:{
            default:'',
            type:String,
        },
    },
}
</script>

<style>
.xm{
    position: relative;
    margin: 20px auto;
    width: 580px;
    cursor: pointer;
}
.fd{
    position: absolute;
    bottom: 0px;
    right:0px;
    width: 51px;
    height: 51px;
    background: url('../../../assets/img/fdj.png')no-repeat;
}
</style>